import { Link } from "react-router-dom";
import { useT } from "@/content/landing";
import { BrandLogo } from "@/components/BrandLogo";
import { scrollToId } from "./scroll";
export function Footer() {
  const t = useT();
  return <footer className="border-t border-[#E8ECF1] bg-white py-14 text-[#64748B]">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <BrandLogo className="h-14" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#94A3B8]">
              {t.footer.blurb}
            </p>
          </div>
          <nav aria-label="Seitenabschnitte">
            <h2 className="font-display text-xs font-semibold tracking-[0.18em] text-[#94A3B8] uppercase">
              Übersicht
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              {t.nav.map(item => <li key={item.href}>
                  <a href={item.href} onClick={e => {
                e.preventDefault();
                scrollToId(item.href.slice(1));
              }} className="transition-colors hover:text-[#3B82F6]">
                    {item.label}
                  </a>
                </li>)}
              <li>
                <Link to="/angebot" className="transition-colors hover:text-[#3B82F6]">
                  {t.services.bandCta}
                </Link>
              </li>
            </ul>
          </nav>
          <nav aria-label="Rechtliches">
            <h2 className="font-display text-xs font-semibold tracking-[0.18em] text-[#94A3B8] uppercase">
              Rechtliches
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              {t.footer.legal.map(item => <li key={item.to}>
                  <Link to={item.to} className="transition-colors hover:text-[#3B82F6]">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div aria-hidden className="mt-12 h-px w-full bg-[#E8ECF1]" />
        <div className="mt-6 flex flex-col gap-2 text-xs text-[#94A3B8] sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} Positivup · {t.brand.domain} · {t.footer.rights}
          </p>
          <p>{t.footer.disclaimer}</p>
        </div>
      </div>
    </footer>;
}